import React from 'react';
import { deleteDoc, doc } from 'firebase/firestore';
import {ref, listAll, deleteObject} from "firebase/storage";
import {db, storage, newsCollectionName} from "../../../components/Firebase/Firebase";
import { useLoading } from '../../../components/context/LoadingContext';
import {Button} from "@mui/material";
import '../NewsPage.css'
import {FaRegTrashAlt} from "react-icons/fa";
import {MdEdit} from "react-icons/md";
import {useNavigate} from "react-router-dom";

const NewsItem = ({ news, onNewsUpdated, collectionName = newsCollectionName, dateFieldKey = 'date', editSource }) => {
    const [isLoading, setIsLoading] = useLoading();

    const navigate = useNavigate();

    const deleteNewsFiles = async (newsId) => {
        const storageRef = ref(storage, `${newsCollectionName}/${newsId}`);
        try {
            const fileList = await listAll(storageRef);
            if (fileList.items.length === 0) {
                console.log('Папка пуста или не существует');
                return;
            }
            const fileDeletionPromises = fileList.items.map(fileRef => deleteObject(fileRef));
            await Promise.all(fileDeletionPromises);
            console.log(`All files in news/${newsId} deleted successfully.`);
        } catch (error) {
            console.error(`Error deleting files in news/${newsId}: `, error);
        }
    };

    const handleDelete = async () => {
        setIsLoading(true);
        try {
            await deleteDoc(doc(db, collectionName, news.id));
            await deleteNewsFiles(news.id);
            console.log('News item deleted successfully');
            onNewsUpdated();
        } catch (error) {
            console.error('Error removing document: ', error);
        }
        setIsLoading(false);
    };

    const handleEdit = () => {
        navigate(`/news/edit/${news.id}`, { state: { news, sourceCollection: collectionName, editSource } });
    };

    return (
        <tr>
            <td>{news.title}</td>
            <td>{news[dateFieldKey] ? new Date(news[dateFieldKey]).toLocaleString() : '-'}</td>
            <td className='actions'>
                <div className='actions d-flex align-items-center'>
                    <Button className='success' color="success" onClick={handleEdit}><MdEdit/></Button>
                    <Button className='error' color="error" onClick={handleDelete}><FaRegTrashAlt/></Button>
                </div>
            </td>
        </tr>
    );
};

export default NewsItem;
